import {
  AutoComplete,
  Button,
  Input,
  Space,
  Spin,
  Tag,
  message,
  Form,
} from "antd";
import React from "react";
import { apiCallPost, apiCallPostCancellable } from "../fns/util";
import _ from "lodash";
import PhoneInput from "react-phone-number-input";

class InviteDelegate extends React.Component {
  state = {
    searchResultsOSWB: [],
    searchResultsAIOS: [],
    isSaving: false,
    isSearchingOSWB: false,
    isSearchingAIOS: false,
    newUser: { name: "", email: "", phone: "" },
  };
  handleSearch = async (searchText, isAIOS = false) => {
    if (!searchText || (searchText && searchText.length <= 2)) {
      return;
    }
    let token = await this.props.context.provideToken();
    let apiUrl = "/conference2023/searchForParticipants";
    if (isAIOS) {
      apiUrl = "/conference2023admin/searchAios";
    }
    let stateKey = "isSearchingOSWB";
    if (isAIOS) {
      stateKey = "isSearchingAIOS";
    }
    try {
      this.setState({ [stateKey]: true });
      let res = await apiCallPostCancellable(token, apiUrl, {
        prefix: searchText,
      });
      if (res) {
        if (isAIOS) {
          this.setState({
            searchResultsAIOS: res.members,
            [stateKey]: false,
          });
          return;
        } else {
          this.setState({
            searchResultsOSWB: res,
            [stateKey]: false,
          });
        }
      }
    } catch (err) {
      console.log(err);
      this.setState({ [stateKey]: false });
    }
  };
  handleAddAuthorFromSearch = async (
    delegate,
    isAIOS = false,
    isNew = false
  ) => {
    let token = await this.props.context.provideToken();

    if (isNew) {
      try {
        this.setState({ isSaving: true });
        message.loading("Inviting delegate...");
        await apiCallPost(token, "/conference2023/inviteDelegate", {
          name: _.startCase(_.lowerCase(this.state.newUser.name)),
          email: this.state.newUser.email,
          mobile: this.state.newUser.phone,
        });
        message.success("Delegate invited successfully.");
        this.setState({
          newUser: { name: "", email: "", phone: "" },
          isSaving: false,
        });
        return;
      } catch (err) {
        this.setState({ isSaving: false });
        console.log(err);
        message.error("Error inviting delegate.");
        return;
      }
    }
    if (!isAIOS && delegate.searchresultsrc === "SRC_CONF") {
      message.error(
        "This delegate is already in the list of delegates for the conference."
      );
      return;
    }

    if (!isAIOS && delegate.searchresultsrc === "SRC_OSWB") {
      try {
        this.setState({ isSaving: true });
        message.loading("Inviting delegate...");
        await apiCallPost(token, "/conference2023/inviteDelegate", {
          name: delegate.full_name,
          email: delegate.email,
          mobile: delegate.mobile_number
            ? "+91" + delegate.mobile_number
            : null,
        });

        message.success("Delegate invited successfully.");
        this.setState({ searchResultsOSWB: [] });
      } catch (err) {
        this.setState({ isSaving: false });

        console.log(err);
        message.error("Error inviting delegate.");
      }
    }
    if (isAIOS) {
      try {
        this.setState({ isSaving: true });

        message.loading("Inviting delegate...");
        await apiCallPost(token, "/conference2023/inviteDelegate", {
          name: _.startCase(_.lowerCase(delegate.name)),
          email: delegate.Email,
          mobile: delegate.Mobile ? "+91" + delegate.Mobile : null,
        });
        message.success("Delegate invited successfully.");
        this.setState({ searchResultsAIOS: [] });
      } catch (err) {
        this.setState({ isSaving: false });
        console.log(err);
        message.error("Error inviting delegate.");
        message.error(err.response.data.details);
      }
    }
  };
  renderSearchOSWB = () => {
    return (
      <>
        <AutoComplete
          popupMatchSelectWidth={true}
          style={{ width: 200 }}
          options={this.state.searchResultsOSWB.map((x) => ({
            label: (
              <Space direction="vertical" size="small">
                <Tag
                  color={x.searchresultsrc === "SRC_OSWB" ? "magenta" : "blue"}
                >
                  {x.full_name}
                </Tag>
                {x.membership_id && <Tag>{x.membership_id}</Tag>}
              </Space>
            ),
            value: `${x.full_name} ${x.email} ${
              x.membership_id ? ` - ${x.membership_id}` : ""
            }`,
            delegate: x,
          }))}
          onSearch={(x) => this.handleSearch(x, false)}
          placeholder="Search for an OSWB Member"
          onSelect={(value, option) => {
            this.handleAddAuthorFromSearch(option.delegate, false);
          }}
        />
        {this.state.isSearchingOSWB && <Spin />}
      </>
    );
  };
  renderSearchAIOS = () => {
    return (
      <>
        <AutoComplete
          popupMatchSelectWidth={true}
          style={{ width: 200 }}
          options={this.state.searchResultsAIOS.map((x) => ({
            label: (
              <Space direction="vertical" size="small">
                <Tag color="magenta">{x.name}</Tag>
                {x.membershipNo && <Tag>{x.membershipNo}</Tag>}
                {x.Mobile && <Tag>{x.Mobile}</Tag>}
              </Space>
            ),
            value: `${x.name} ${x.Email} ${x.Mobile} ${
              x.membershipNo ? ` - ${x.membershipNo}` : ""
            }`,
            delegate: x,
          }))}
          onSearch={(x) => this.handleSearch(x, true)}
          placeholder="Search for an AIOS Member"
          onSelect={(value, option) => {
            this.handleAddAuthorFromSearch(option.delegate, true);
          }}
        />
        {this.state.isSearchingAIOS && <Spin />}
      </>
    );
  };
  renderManualAdd = () => {
    return (
      <Form>
        <Form.Item
          label="Name"
          rules={[
            {
              required: true,
              message: "Please input the name!",
            },
          ]}
        >
          <Input
            placeholder="Name"
            value={this.state.newUser.name}
            onChange={(e) =>
              this.setState({
                newUser: {
                  ...this.state.newUser,
                  name: e.target.value,
                },
              })
            }
          />
        </Form.Item>
        <Form.Item
          label="Email"
          rules={[
            {
              required: true,
              message: "Please input the email!",
            },
          ]}
        >
          <Input
            placeholder="Email"
            value={this.state.newUser.email}
            onChange={(e) =>
              this.setState({
                newUser: {
                  ...this.state.newUser,
                  email: e.target.value,
                },
              })
            }
          />
        </Form.Item>
        <Form.Item
          label="Phone"
          rules={[
            {
              required: true,
              message: "Please input the phone number!",
            },
          ]}
        >
          <PhoneInput
            name="Phone"
            defaultCountry="IN"
            placeholder="Phone"
            value={this.state.newUser.phone}
            onChange={(e) =>
              this.setState({
                newUser: {
                  ...this.state.newUser,
                  phone: e,
                },
              })
            }
          />
        </Form.Item>
        <Button
          onClick={() => this.handleAddAuthorFromSearch(null, false, true)}
          loading={this.state.isSaving}
          type="primary"
          disabled={
            this.state.isSaving ||
            this.state.isSearchingAIOS ||
            this.state.isSearchingOSWB ||
            !this.state.newUser.phone ||
            !this.state.newUser.name ||
            !this.state.newUser.email
          }
        >
          Add Delegate Manually
        </Button>
      </Form>
    );
  };

  render() {
    return (
      <div>
        <h4>Search For Persons Across OSWB</h4>
        {this.renderSearchOSWB()}
        <h4>Search For Persons Across AIOS</h4>
        {this.renderSearchAIOS()}
        <h4>Add Manually (Use only when search turns up nothing)</h4>
        {this.renderManualAdd()}
      </div>
    );
  }
}

export default InviteDelegate;
